import React  from 'react';
import './App.css';
import './Notebook.css';

import NotebookSourceList from './NotebookSourceList.js';
import NotebookChat from './NotebookChat.js';
import NotebookAnalysis from './NotebookAnalysis.js';

import NotebookAddSourcePopup from './NotebookAddSourcePopup.js';
import NotebookPasteTextPopup from './NotebookPasteTextPopup.js';

class NotebookMain extends React.Component {

	constructor(props) {

		super(props);

		this.state = {
			notebookJsonObj: null,
			sourceArray: null,
			sourceIndex: -1,
			ownerYN: false,
			notebookAddSourcePopupYN: false,
			notebookPasteTextPopupYN: false,
			userSettingsJsonObj: null,
		}

		this.refreshData = this.refreshData.bind(this);
		this.setNotebookAddSourcePopupYN = this.setNotebookAddSourcePopupYN.bind(this);
		this.setNotebookPasteTextPopupYN = this.setNotebookPasteTextPopupYN.bind(this);
	}

	async componentDidMount() {
		var userID = this.props.userID;
		var fullName = this.props.fullName;
		this.serverGetUserSettingsData(userID, fullName);
		await this.refreshData();
	}

	async serverGetUserSettingsData(userID, userFullName) {

		if (userID <= 0) {
			return null;
		}

		var baseURLAPI = this.props.baseURLAPI;
		var url = baseURLAPI + "/getusersettingsdata?userid=" + userID;
		url = url + "&userfullname=" + encodeURIComponent(userFullName);
		
		var userSettingsJsonObj = null;
		
		try {
			var res = await fetch(url);
			userSettingsJsonObj = await res.json();
		} catch (err) {
		}

		if (userSettingsJsonObj === null) {
			return;
		}

		this.setState({
			userSettingsJsonObj: userSettingsJsonObj,
		});
	}

	async refreshData() {

		var notebookID = this.props.notebookID;
		var notebookJsonObj = await this.props.serverGetNotebookData(notebookID);
		var sourceArray = await this.props.serverGetSourceList(notebookID);

		var ownerYN = false;
		var userID = this.props.userID;
		if (notebookJsonObj !== null) {
			if (notebookJsonObj.createdUserID === userID) {
				ownerYN = true;
			}
		}

		this.setState({
			notebookJsonObj: notebookJsonObj,
			sourceArray: sourceArray,
			ownerYN: ownerYN,
		});
	}

	setNotebookAddSourcePopupYN(notebookAddSourcePopupYN) {
		this.setState({
			notebookAddSourcePopupYN: notebookAddSourcePopupYN,
		});
	}
	
	setNotebookPasteTextPopupYN(notebookPasteTextPopupYN) {
		this.setState({
			notebookPasteTextPopupYN: notebookPasteTextPopupYN,
		});
	}
	
	renderNotebookAddSourcePopup() {
		return (
			<NotebookAddSourcePopup
				renderPopupYN={this.state.notebookAddSourcePopupYN}
				baseURLAPI={this.props.baseURLAPI}
				userID={this.props.userID}
				fullName={this.props.fullName}
				companyID={this.props.companyID}
				notebookAppUserType={this.props.notebookAppUserType}
				notebookID={this.props.notebookID}
				showToast={this.props.showToast}
				getLang={this.props.getLang}
				serverGetNotebookData={this.props.serverGetNotebookData}
				setNotebookAddSourcePopupYN={this.setNotebookAddSourcePopupYN}
				setNotebookPasteTextPopupYN={this.setNotebookPasteTextPopupYN}
				refreshData={this.refreshData}
			/>
		);		
	}

	renderNotebookPasteTextPopup() {
		return (
			<NotebookPasteTextPopup
				renderPopupYN={this.state.notebookPasteTextPopupYN}
				baseURLAPI={this.props.baseURLAPI}
				userID={this.props.userID}
				fullName={this.props.fullName}
				companyID={this.props.companyID}
				notebookAppUserType={this.props.notebookAppUserType}
				notebookID={this.props.notebookID}
				sourceIndex={this.props.sourceIndex}
				sourceArray={this.state.sourceArray}
				showToast={this.props.showToast}
				getLang={this.props.getLang}
				serverGetNotebookData={this.props.serverGetNotebookData}
				serverDownloadTextFile={this.props.serverDownloadTextFile}
				setNotebookPasteTextPopupYN={this.setNotebookPasteTextPopupYN}
				refreshData={this.refreshData}
			/>
		);		
	}

	renderSources() {
		return (
			<NotebookSourceList
				baseURLAPI={this.props.baseURLAPI}
				userID={this.props.userID}
				fullName={this.props.fullName}
				companyID={this.props.companyID}
				notebookAppUserType={this.props.notebookAppUserType}
				userSettingsJsonObj={this.state.userSettingsJsonObj}
				notebookID={this.props.notebookID}
				notebookJsonObj={this.state.notebookJsonObj}
				ownerYN={this.state.ownerYN}
				sourceArray={this.state.sourceArray}
				sourceIndex={this.state.sourceIndex}
				showToast={this.props.showToast}
				getLang={this.props.getLang}
				getDateStringFromUnixTimeSec={this.props.getDateStringFromUnixTimeSec}			
				setSourceIndex={this.props.setSourceIndex}
				setNotebookAddSourcePopupYN={this.setNotebookAddSourcePopupYN}
				setNotebookPasteTextPopupYN={this.setNotebookPasteTextPopupYN}
				refreshData={this.refreshData}
			/>
		);
	}
	
	renderChat() {
		return (
			<NotebookChat
				baseURLAPI={this.props.baseURLAPI}
				language={this.props.language}
				userID={this.props.userID}
				fullName={this.props.fullName}
				companyID={this.props.companyID}
				notebookAppUserType={this.props.notebookAppUserType}
				notebookID={this.props.notebookID}
				notebookJsonObj={this.state.notebookJsonObj}
				ownerYN={this.state.ownerYN}
				sourceArray={this.state.sourceArray}
				showToast={this.props.showToast}
				getLang={this.props.getLang}
				getDateStringFromUnixTimeSec={this.props.getDateStringFromUnixTimeSec}			
			/>
		);
	}
	
	renderAnalysis() {
		return (
			<NotebookAnalysis
				baseURLAPI={this.props.baseURLAPI}
				userID={this.props.userID}
				fullName={this.props.fullName}
				companyID={this.props.companyID}
				notebookAppUserType={this.props.notebookAppUserType}
				notebookID={this.props.notebookID}
				notebookJsonObj={this.state.notebookJsonObj}
				ownerYN={this.state.ownerYN}
				sourceArray={this.state.sourceArray}
				showToast={this.props.showToast}
				getLang={this.props.getLang}
				getDateStringFromUnixTimeSec={this.props.getDateStringFromUnixTimeSec}			
				serverDownloadTextFile={this.props.serverDownloadTextFile}
				setSourceIndex={this.props.setSourceIndex}
				setDocType={this.props.setDocType}
				refreshData={this.refreshData}
			/>
		);
	}
	
	render() {
		return (
			<div className="NotebookMainTopContainer">
				{this.renderNotebookAddSourcePopup()}
				{this.renderNotebookPasteTextPopup()}
				<div className="NotebookMainSources">{this.renderSources()}</div>
				<div className="NotebookMainChat">{this.renderChat()}</div>
				<div className="NotebookMainAnalysis">{this.renderAnalysis()}</div>
			</div>
		);
	}
}

export default NotebookMain;

